import { localizeReducer as localize } from 'react-localize-redux';
import { reducer as notifications } from 'react-notification-system-redux';
import { firebaseReducer as firebase } from 'react-redux-firebase';
import { combineReducers } from 'redux';

import auth, { USER_INVALIDATED } from './auth';
import checkout from './checkout/reducer';
import coupons from './coupons/reducer';
import global from './global/reducer';
import menu from './menu';

/**
|--------------------------------------------------
| Reducer index
| Combine reducers from different modules
|--------------------------------------------------
*/
const appReducer = () =>
  combineReducers({
    auth,
    checkout,
    coupons,
    firebase,
    global,
    localize,
    menu,
    notifications
  });

/**
 * Root reducer for clearing state on logout
 */
const createRootReducer = () => (state, action) => {
  if (action.type === USER_INVALIDATED) {
    const { localize, global, auth } = state;
    state = { localize, global, auth };
  }
  return appReducer()(state, action);
};

export default createRootReducer;
